import { Navigate } from "react-router";

import { useAuthenticationContext } from "../auth/use-authentication-context";

export const AdminRouteGuard: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { user, isSuperuserInAdminMode } = useAuthenticationContext();

  if (!user?.id) return <Navigate to="/login" />;

  if (!isSuperuserInAdminMode) return <Navigate to="/account/orders" />;

  return children;
};
